import React, { useEffect, useState } from "react";

export default function AdSense({ slot }) {
  const [ready, setReady] = useState(false);

  useEffect(() => {
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      setReady(true);
    } catch (e) {
      console.error(e);
      setReady(false);
    }
  }, []);

  if (!ready) return null;

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block" }}
      data-ad-client="ca-pub-6413251379128291"
      data-ad-slot={slot}
      data-ad-format="auto"
      data-full-width-responsive="true"
    />
  );
}
